import React, { Component, PropTypes } from 'react';
import './checkbox.scss';
import URLService from 'service/URLService';

export default class Checkbox extends Component {
    static propTypes = {
        disabled: PropTypes.bool,
        className: PropTypes.string,
        onToggle: PropTypes.func,
    }

    handleClick = (ev) => {
        if(this.props.onToggle) {
            this.props.onToggle(true);
        }
    }

    render() {
        return (
            <div className={`checkbox-wrapper`} onClick={this.handleClick}>
                <input {...(this.props.checked ? {checked: true} : {})} type="checkbox" />
                <span className="checkbox-label">{this.props.children}</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/checkbox/Checkbox.js